// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"ca22b972","384":"9e8a66b6","396":"fcf5a682","404":"fdacbc01","456":"5b961df0","468":"a74b7e7a","668":"6dbc47dd","692":"29482727","792":"6b4baff9","828":"c3e971c7","948":"c9535233"}[chunkId] + ".chunk.js";
};